<app-uni-page *ngIf="isPageReady" [parent]="this" pageTitle="In-Process: Job Orders {{ getTitle() }}" [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate">
</app-uni-page>

<ng-template #bodyTemplate>
  <p-splitter class="w-full grow" layout="vertical" styleClass="h-full" [panelSizes]="[50, 50]">
    <ng-template pTemplate>
      <div class="flex h-full w-full flex-col overflow-hidden">
        <div class="my-2 mr-4 flex shrink-0 items-center gap-2.5">
          <p-selectButton [options]="allStatuses" [(ngModel)]="currentJoStatus" dataKey="id" optionLabel="name">
          </p-selectButton>
          <button *ngIf="isModeIncomplete()" pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-plus"
            [disabled]="joPullBatchId == null" (click)="createNewBatch()">
            <span>New Batch</span>
          </button>
        </div>
        <app-ag-grid #gridJoHeaders gridId="gridJoHeaders" [gridOptions]="johGridOptions"
          class="min-h-0 flex-1"></app-ag-grid>

        <ng-template #auditJoCell let-row>
          <button pButton type="button" class="p-button-text p-button-sm" (click)="goJoAudit(row)">Audit JO</button>
        </ng-template>

        <ng-template #editJohNotesCell let-row>
          <button pButton type="button" class="p-button-text p-button-sm"
            [ngClass]="{ 'btn-has-data': hasJohNotes(row) }" (click)="editJohNotes(row)">
            Notes
          </button>
        </ng-template>

        <ng-template #viewDocCell let-row>
          <button pButton type="button" class="p-button-text p-button-sm" *ngIf="hasAddonDocs(row)"
            (click)="viewAddonDocs(row)">
            View Documents
          </button>
        </ng-template>
      </div>
    </ng-template>

    <ng-template pTemplate>
      <div class="flex h-full w-full flex-col">
        <p-tabView (onChange)="onTabChanged($event)" class="uni-tabview h-full w-full" styleclass="h-full">
          <p-tabPanel header="Details">
            <app-ag-grid #gridJoDetails gridId="gridJoDetails" [gridOptions]="jodGridOptions"
              [rowData]="joDetails"></app-ag-grid>
            <ng-template #editJodNotesCell let-row>
              <button pButton type="button" class="p-button-text p-button-sm"
                [ngClass]="{ 'btn-has-data': hasJodNotes(row) }" (click)="editJodNotes(row)">
                Notes
              </button>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel header="Information">
            <app-jo-info [entity]="currentJoHeader"></app-jo-info>
          </p-tabPanel>
          <p-tabPanel header="Billing Info">
            <div *ngIf="currentJoHeader" class="flex flex-wrap gap-4 p-4">
              <div class="w-full md:w-[calc(33%-1rem)] xl:w-[calc(25%-1rem)] qb-detail-card qb-primary-tint p-4">
                <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">Address</div>
                <table class="qb-info-table flush">
                  <tr>
                    <td class="label">Name</td>
                    <td class="value">{{ currentJoHeader.billingName }}</td>
                  </tr>
                  <tr>
                    <td class="label">Address 1</td>
                    <td class="value">{{ currentJoHeader.billingAddress1 }}</td>
                  </tr>
                  <tr *ngIf="currentJoHeader.billingAddress2">
                    <td class="label">Address 2</td>
                    <td class="value">{{ currentJoHeader.billingAddress2 }}</td>
                  </tr>
                  <tr *ngIf="currentJoHeader.billingAddress3">
                    <td class="label">Address 3</td>
                    <td class="value">{{ currentJoHeader.billingAddress3 }}</td>
                  </tr>
                  <tr>
                    <td class="label">City</td>
                    <td class="value">{{ currentJoHeader.billingCity }}</td>
                  </tr>
                  <tr>
                    <td class="label">State</td>
                    <td class="value">{{ currentJoHeader.billingState }}</td>
                  </tr>
                  <tr>
                    <td class="label">Zip</td>
                    <td class="value">{{ currentJoHeader.billingZipCode }}</td>
                  </tr>
                </table>
              </div>
              <div class="w-full md:w-[calc(33%-1rem)] xl:w-[calc(25%-1rem)] qb-detail-card qb-primary-tint p-4">
                <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">Contact</div>
                <table class="qb-info-table flush">
                  <tr>
                    <td class="label">Telephone</td>
                    <td class="value">{{ currentJoHeader.billingTelephone }}</td>
                  </tr>
                  <tr *ngIf="currentJoHeader.billingExt">
                    <td class="label">Extension</td>
                    <td class="value">{{ currentJoHeader.billingExt }}</td>
                  </tr>
                  <tr>
                    <td class="label">Email</td>
                    <td class="value">{{ currentJoHeader.billingEmail }}</td>
                  </tr>
                  <tr>
                    <td class="label">Portal Name</td>
                    <td class="value">{{ currentJoHeader.portalName }}</td>
                  </tr>
                </table>
              </div>
              <div class="w-full mt-2">
                <button *ngIf="canEditAddress" pButton type="button" class="p-button-raised"
                  (click)="editAddress('billing', 'Billing')">
                  Edit Address
                </button>
                <span *ngIf="currentJoHeader?.manifestId != null" class="ml-5">This address is part of a manifest</span>
              </div>
            </div>
            <div *ngIf="!currentJoHeader">
              <h5>No Billing Info Found</h5>
            </div>
          </p-tabPanel>
          <p-tabPanel header="Shipping Info">
            <div *ngIf="currentJoHeader" class="flex flex-wrap gap-4 p-4">
              <div class="w-full md:w-[calc(33%-1rem)] xl:w-[calc(25%-1rem)] qb-detail-card qb-primary-tint p-4">
                <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">Address</div>
                <table class="qb-info-table flush">
                  <tr>
                    <td class="label">Name</td>
                    <td class="value">{{ currentJoHeader.shippingName }}</td>
                  </tr>
                  <tr>
                    <td class="label">Address 1</td>
                    <td class="value">{{ currentJoHeader.shippingAddress1 }}</td>
                  </tr>
                  <tr *ngIf="currentJoHeader.shippingAddress2">
                    <td class="label">Address 2</td>
                    <td class="value">{{ currentJoHeader.shippingAddress2 }}</td>
                  </tr>
                  <tr *ngIf="currentJoHeader.shippingAddress3">
                    <td class="label">Address 3</td>
                    <td class="value">{{ currentJoHeader.shippingAddress3 }}</td>
                  </tr>
                  <tr>
                    <td class="label">City</td>
                    <td class="value">{{ currentJoHeader.shippingCity }}</td>
                  </tr>
                  <tr>
                    <td class="label">State</td>
                    <td class="value">{{ currentJoHeader.shippingState }}</td>
                  </tr>
                  <tr>
                    <td class="label">Zip</td>
                    <td class="value">{{ currentJoHeader.shippingZipCode }}</td>
                  </tr>
                </table>
              </div>
              <div class="w-full md:w-[calc(33%-1rem)] xl:w-[calc(25%-1rem)] qb-detail-card qb-primary-tint p-4">
                <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">Contact</div>
                <table class="qb-info-table flush">
                  <tr>
                    <td class="label">Telephone</td>
                    <td class="value">{{ currentJoHeader.shippingTelephone }}</td>
                  </tr>
                  <tr *ngIf="currentJoHeader.shippingExt">
                    <td class="label">Extension</td>
                    <td class="value">{{ currentJoHeader.shippingExt }}</td>
                  </tr>
                </table>
              </div>
              <div class="w-full mt-2">
                <button *ngIf="canEditAddress" pButton type="button" class="p-button-raised"
                  (click)="editAddress('shipping', 'Shipping')">
                  Edit Address
                </button>
              </div>
            </div>
            <div *ngIf="!currentJoHeader">
              <h5>No Shipping Info Found</h5>
            </div>
          </p-tabPanel>
          <p-tabPanel header="Purchase Orders">
            <app-ag-grid [gridOptions]="podGridOptions" [rowData]="poDetails"></app-ag-grid>
          </p-tabPanel>
          <p-tabPanel *ngIf="isModeComplete() || isModeAll()" header="WIP - Pulled/Received">
            <app-ag-grid [gridOptions]="itdGridOptions" [rowData]="itemDetails"></app-ag-grid>
          </p-tabPanel>
          <p-tabPanel *ngIf="!isModeIncomplete()" header="Invoices">
            <app-ag-grid [gridOptions]="invhGridOptions" [rowData]="invoiceHeaders"></app-ag-grid>
            <ng-template #invdButtonsCell let-row>
              <button pButton type="button" class="p-button-text p-button-sm" (click)="goPrintableInvoice(row)">View
                Invoice</button>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel header="Returns">
            <app-ag-grid [gridOptions]="rradGridOptions" [rowData]="returnRequestDetails"></app-ag-grid>
          </p-tabPanel>
        </p-tabView>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>